import { render, staticRenderFns } from "./EditCustomerGroup.vue?vue&type=template&id=89b9cd74&scoped=true&"
import script from "./EditCustomerGroup.vue?vue&type=script&lang=js&"
export * from "./EditCustomerGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerGroup.vue?vue&type=style&index=0&id=89b9cd74&lang=scss&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b9cd74",
  null
  
)

export default component.exports